module.exports = __webpack_public_path__ + "site-build/img/detail.c602a9d3.jpg";